import { NavLink } from "react-router-dom";
import { useState } from "react";
import { primaryNav, site } from "@/config/site";

export function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <div className="header-inner">
        <NavLink className="wordmark" to="/" end onClick={() => setOpen(false)}>
          Jay van Zyl
        </NavLink>
        <button
          type="button"
          className="nav-toggle"
          aria-expanded={open}
          aria-controls="primary-navigation"
          onClick={() => setOpen((value) => !value)}
        >
          Menu
        </button>
        <nav
          id="primary-navigation"
          className={open ? "primary-nav is-open" : "primary-nav"}
          aria-label="Primary"
        >
          {primaryNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
            >
              {item.label}
            </NavLink>
          ))}
          <NavLink
            className="button header-cta"
            to="/work-with-jay"
            onClick={() => setOpen(false)}
          >
            Work with Jay
          </NavLink>
        </nav>
      </div>
      <span className="visually-hidden">{site.tagline}</span>
    </header>
  );
}
